export const DS_AI_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Whether the user asks for reduced motion; for motion run from script, read when it starts. */
export const prefersReducedMotion = (): boolean =>
	window.matchMedia(DS_AI_REDUCED_MOTION_QUERY).matches;

/** A scripted scroll: smooth, or a jump under reduced motion. */
export const dsAiScrollBehavior = (): ScrollBehavior =>
	prefersReducedMotion() ? 'auto' : 'smooth';
